<template>
  <TopNav />
  <SideBar />
   <main class="ml-12 pl-3">
  <div class="row mt-5 pt-5 ms-5">
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-6">
        <h5 class="text-center">{{staffName}} İş Dökümü</h5>
        <h6 class="text-center">{{trh(bas)}} ve {{trh(son)}} tarihleri arası</h6>
        
      </div>
    </div>
   <div class="row">
    <div class="col-md-4">
     
        <router-link class="btn btn-info" :to="{ name: 'Kisiler', 
                      params: { datefirst: this.bas, datesecond: this.son }}"> 
                    Geri Dön 
        </router-link>
     <br/>
     <p></p>
    </div>
    <div class="col-md-6"></div>
    <div class="col-md-2"><button class="btn btn-info" @click="toExcel"><i class="bi bi-download"></i> Excele Aktar</button></div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <table
          id="datatable"
          class="table table-striped table-bordered mt-3 pt-3"
        >
          <thead>
    
            <tr>
              <th>Görev ID</th>
              <th>Görev</th>
              <th>Müşteri</th>
              <th>Başlangıç</th>
              <th>Bitiş</th>
              <th>İş Durumu</th>
              <th>Çalışan Zamanı</th>
              <th>Açıklama</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="{ active: index == currentIndex }"
              v-for="(staff, index) in this.staffItems"
              :key="index" 
            >
            <td>{{staff.task_id}}</td>
            <td>{{staff.task_name}}</td>
            <td>{{staff.client}}</td>
            <td>{{trh(staff.start_date)}}</td>
            <td>{{trh(staff.end_date)}}</td>
            <td>{{staff.task_status}}</td>
            <td>{{staff.sum_hour}}</td>
            <td>
              <span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" :title="staff.task_description">
                <button class="btn btn-success"><i class="bi bi-eye"></i></button>
              </span>
            </td>



              
            </tr>
          </tbody>
        </table>
      </div>
    

   
  
    </div>
  </div>
   </main>
</template>
<script>
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";


import $ from "jquery";
import { mapState } from "vuex";
import StaffDataService from "../services/StaffDataService";import TopNav from "@/components/TopNav.vue";
import SideBar from "@/components/SideBar.vue";
import TableToExcel from "table-to-excel/table-to-excel.js"

export default {
    name: "Kisi",components: {
      TopNav,
      SideBar},
    computed: mapState(["access_token", "api_url"]),
    mounted() {
    StaffDataService.get(this.$route.params.id)
      .then(response => {
        this.staffName=response.data.username
      }).catch(e => {
        console.log(e.response.data)
      })
    const requestParams = {
      method: "GET",
      headers: { Authorization: `Bearer ` + this.access_token },
    };
    fetch(this.api_url+"sr/"+this.staffid+"/"+this.bas+"/"+this.son, requestParams)
      .then((response) => response.json())
      .then((data) => {
        this.staffItems = data;
        
        setTimeout(() => {
          $("#datatable").DataTable({
            language: {
              url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/Turkish.json",
            },
            lengthMenu: [
              [10, 25, 50, -1],
              [10, 25, 50, "Hepsi"],
            ],
            dom: 'Bfrtip',
            buttons: [
                'copy', 'csv', 'excel', 'pdf', 'print'
            ],
            pageLength: -1,
          });
        });
      });
  },
  data(){
        return{
            staffid: this.$route.params.id,
            bas: this.$route.params.datefirst,
            son: this.$route.params.datesecond,
            staffItems:[],
            staffName: null
        }
    },
    methods: {
      toExcel(){
        var tableToExcel=new TableToExcel();
        tableToExcel.render("datatable")
      },
      trh(myText){
        let my_arr = myText.split("-")
        return my_arr[2]+"."+my_arr[1]+"."+my_arr[0]
      }
    }
}
</script>
<style scoped>
@import "~datatables.net-dt/css/jquery.dataTables.min.css";
.active {
  background-color: azure !important;
}
th {
  background-color: lightblue;
  border-radius: 5px !important;
}
</style>